// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"41":"147b7dcf","235":"3392c2a7","345":"060880f3","459":"5279d5bc","552":"86f3a5a7","608":"eead7cad","623":"732c20a5","652":"c45909f2","679":"dc58a2e5","834":"ffff696b","915":"153c4351","977":"a147d34f"}[chunkId] + ".js";
};